import React from 'react'

function News() {
    return (
        <div>
            <h1>Actualidad</h1>
        </div>
    )
}

export default News
